module.exports = __webpack_public_path__ + "static/media/Crude Oil transportation Services .921bc9d9.png";